import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'aura-success-button',
  imports: [MatButtonModule],
  templateUrl: './success-button.component.html',
  styleUrl: './success-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraSuccessButtonComponent {
  readonly label = input<string>('Terminer');
  readonly successLabel = input<string>('Terminé');
  readonly submitting = input<boolean>(false);
  readonly success = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly buttonType = input<'button' | 'submit'>('button');
  readonly customClass = input<string>('');

  readonly clicked = output<void>();

  readonly isInteractionDisabled = computed(() => this.disabled() || this.submitting() || this.success());

  onClick(event: Event): void {
    if (this.isInteractionDisabled()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.clicked.emit();
  }
}
